import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile/mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initialiseInterceptor from './api/interceptor';
import { SplashScreen } from '@capacitor/splash-screen';
import {registerServiceWorker} from './firebase'
initialiseInterceptor();
registerServiceWorker();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// Keep the native splash up until the first screen has painted (the page loads
// remote scripts first), then fade it out. The config also auto-hides it after
// 10s as a safety net. No-op in the browser.
requestAnimationFrame(() => {
    setTimeout(() => SplashScreen.hide({ fadeOutDuration: 250 }).catch(() => {}), 50);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
